module.exports = __webpack_public_path__ + "img/slogan.ef6ae97d.svg";